export const ARTIST_MAX_LIMIT: number = 3;

export const FORM_ARRAY_KEY = "releaseArtists";
